import {type CheckboxProps as AriaCheckboxProps} from 'react-aria-components'
import * as StyledCheckbox from './checkbox.styled'

export interface CheckboxProps extends AriaCheckboxProps {
    fontSize?: 'xs' | 'sm' | 'md' | 'md-lg' | 'lg' | 'xl' | '2xl'
    checkboxSize?: 'sm' | 'md' | 'lg'
    children?: React.ReactNode
}

export function Checkbox({
    children,
    fontSize = 'md',
    checkboxSize = 'md',
    ...props
}: CheckboxProps) {
    return (
        <StyledCheckbox.Root {...props} $fontSize={fontSize} $checkboxSize={checkboxSize}>
            {({isIndeterminate}) => (
                <>
                    <div className="checkbox">
                        <svg viewBox="0 0 18 18" aria-hidden="true">
                            {isIndeterminate ? (
                                <rect x={1} y={7.5} width={15} height={3} />
                            ) : (
                                <polyline points="1 9 7 14 15 4" />
                            )}
                        </svg>
                    </div>
                    {children ? children : null}
                </>
            )}
        </StyledCheckbox.Root>
    )
}
